/* global axios */
import ApiClient from './ApiClient';

class AttributeAPI extends ApiClient {
  constructor() {
    super('custom_attribute_definitions', { accountScoped: true });
  }

  getAttributesByModel() {
    return axios.get(this.url);
  }

  updateOrder(data, attributeModel) {
    return axios.post(`${this.url}/update_order`, {
      data,
      attribute_model: attributeModel
    });
  }
}

export default new AttributeAPI();
